/** UUID v4 (crypto.randomUUID есть в браузере и Android WebView). */
export function uid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // фолбэк
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/** Временный локальный id оптимистичной сущности (до синка). */
export function tempId(): string {
  return `temp_${uid()}`;
}

export function isTempId(id: string): boolean {
  return id.startsWith('temp_');
}
